/**
 * Shorten events duration by ending events early or starting events late.
 */
export enum ShortenEventScopeType {
    EndEarly = 'End_Early',
    StartLate = 'Start_Late',
    None = 'None',
}
